import { Component, ChangeDetectorRef, ComponentFactoryResolver, Input } from '@angular/core';
import { MachineLearningResetWizardService } from '../../../services/machine.learning/machine-learning-reset-wizard.service';
import { ActivatedRoute } from '@angular/router';
import { MachineLearningWizardComponent } from '../machine-learning-wizard.component';
import { MlSelectApplicationComponent } from './ml-select-application/ml-select-application.component';
import { ValuesExchangeProvider } from '@nrwl/common-lib';

@Component({
  selector: 'ml-wizard-select-application',
  templateUrl: "../../../wizard.template.html",
  styleUrls: ["../../../wizard.component.style.scss", "../machine-learning-wizard.style.scss", "../../../wizard.button.style.scss"]
})
export class MlSelectApplicationWizardComponent extends MachineLearningWizardComponent {
  constructor(
    mlResetWizardService: MachineLearningResetWizardService,
    changeDetectorRef: ChangeDetectorRef,
    activatedRoute: ActivatedRoute,
    factoryResolver: ComponentFactoryResolver,
    private exchange: ValuesExchangeProvider) {
      super(mlResetWizardService, changeDetectorRef, activatedRoute, factoryResolver);
  }

  resolveComponentType() {
      return MlSelectApplicationComponent;
  }

  toggleFinish() {
    let appObject = this.wizardService.onApply();
    this.exchange.notifyListeners('ml_reset_option', appObject);
    this.toggleClose();
  }
}
